export default __webpack_public_path__ + "media/images/80-db28a73760702077a8605fafd7898a40.jpg";